/* Paws in Clouds — scroll-triggered animations. Replaces IntersectionObserver logic from Next.js components. */

(function () {
  'use strict';
  if (typeof IntersectionObserver === 'undefined') {
    document.querySelectorAll('.pic-hidden-until-scroll').forEach(function (el) {
      el.classList.remove('pic-hidden-until-scroll');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var animationClass = el.dataset.picAnimation || 'pic-fade-in-up';
      var delay = parseInt(el.dataset.picDelay || '0', 10);
      setTimeout(function () {
        el.classList.remove('pic-hidden-until-scroll');
        el.classList.add(animationClass);
      }, delay);
      observer.unobserve(el);
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

  function observeAll() {
    document.querySelectorAll('.pic-hidden-until-scroll').forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeAll);
  } else {
    observeAll();
  }
})();
